import { Box, Divider, Flex, Stack, Text } from '@mantine/core';
import { Fragment } from 'react';

import { useStepStyles } from '../../hooks/useStepStyles';
import { getStepStructure } from '../../utils/getStepStructure';
import StepperItem from './StepperItem';

import type { ITrackingConfig, StepStatus } from '../../types';

interface IPropsConversionStepper {
  config: ITrackingConfig;
  currentProcess?: string | null;
  currentStatus?: StepStatus;
}

export default function ConversionStepper(props: IPropsConversionStepper) {
  const { config, currentProcess, currentStatus } = props;
  const parentStepStyles = useStepStyles({ type: 'parent' });
  const subStepStyles = useStepStyles({ type: 'sub' });
  const stepStructure = getStepStructure(config, currentProcess, currentStatus);

  return (
    <Box mt="sm" py="xl">
      <Flex justify="space-between" gap={0}>
        {stepStructure.length > 0 ? (
          stepStructure.map((step, index) => (
            <Fragment key={step.id}>
              <Box>
                <StepperItem step={step} stepStyles={parentStepStyles} />
                {step.subSteps.length > 0 && (
                  <Stack pl={44} mt="sm" gap="xs">
                    {step.subSteps.map((subStep) => (
                      <StepperItem key={`${step.id}-${subStep.id}`} step={subStep} stepStyles={subStepStyles} />
                    ))}
                  </Stack>
                )}
              </Box>
              {index < stepStructure.length - 1 && (
                <Divider style={{ flex: 1 }} size="sm" mt={20} color={step.status === 'done' ? 'green.5' : 'gray.3'} />
              )}
            </Fragment>
          ))
        ) : (
          <Text>조회된 결과가 없습니다.</Text>
        )}
      </Flex>
    </Box>
  );
}
